<script lang="ts" setup>
import { getCurrentInstance, ref } from "vue";
import { useField } from "vee-validate";
import { useSlots } from "vue";
//@ts-ignore
import BaseInput from "@/components/form/_base.vue";

interface Props {
    value?: string | number | boolean;
    name: string;
    label: string;
}

const props = withDefaults(defineProps<Props>(), {
    value: undefined,
    name: undefined,
    label: undefined,
});

const slots = useSlots();
const hasSlot = (name: string) => !!slots[name];

const { handleChange, errorMessage, meta, value: inputValue } = useField(ref(props.name), undefined, { type: "checkbox", checkedValue: props.value });
const uid = getCurrentInstance()?.uid;
</script>

<template>
    <BaseInput :errorMessage="errorMessage" :meta="meta" :name="name">
        <div class="flex justify-start">
            <div class="form-check flex flex-row gap-[16px]">
                <input
                    id="`check_${name}`"
                    class="form-check-input focus:!text-gold focus:!ring-gold appearance-none mt-[4px] h-4 w-4 border border-gray-300 rounded-sm bg-white checked:!bg-gold checked:border-gold hover:checked:text-gold focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
                    type="checkbox"
                    @change="handleChange(value)"
                    :name="name"
                />
                <label class="form-check-label inline-block text-white font-light" :for="`check_${name}`">
                    <slot v-if="hasSlot('default')"></slot>
                    <template v-else>{{ label }}</template>
                </label>
            </div>
        </div>
    </BaseInput>
</template>

<style scoped>
.md .form-check {
    align-items: center;
}
.md input {
    margin-top: 0;
    width: 30px;
    height: 30px;
    background-color: #09132110;
    border-color: #09132110;
}
</style>
